var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnionClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.41421 0.585786L0 2L7.07107 9.07107L7.07124 9.07089L7.07166 9.07131L14.1427 2.00025L12.7285 0.586033L7.07149 6.24306L1.41421 0.585786Z",
    fill: "#FF6C01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionClosed);
export default __webpack_public_path__ + "static/media/UnionClosed.3e485d6848e08fc90005f7811af4d1eb.svg";
export { ForwardRef as ReactComponent };